import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Contact";
import { Projects } from "@/components/site/Projects";

export default function ProjectsPage() {
  const [projects, setProjects] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Completed Projects | LaunchLab";
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([]));
  }, []);

  return (
    <div data-testid="projects-page" className="relative w-full max-w-[100vw] overflow-x-clip text-slate-100 min-h-screen">
      <Header />
      <div className="pt-16">
        <Projects projects={projects} />
      </div>
      <Footer />
    </div>
  );
}
